export const sizes = {
  topBarHeight: 78,
  // The v2 mockup's `.top{height:56px}`.
  topBarHeightV2: 56,
};

export const zIndices = {
  topBar: 1,
  sideBarOverlay: 2,
  sideBar: 3,
  popOver: 4,
  overlay: 5,
  overlayContent: 6,
  toast: 7,
};
